interface IconProps {
  className?: string;
}

/**
 * Lucide "badge-percent" glyph. Inlined because the shared sprite
 * (~/components/Icon) does not include it yet. Rendered as a solid
 * brand-colored badge with an inverse percent sign, matching the
 * DubaiExpress USP tile style.
 */
const BadgePercentIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden className={className}>
    <path
      d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
      fill="var(--icon-brand)"
    />
    <path
      d="m15 9-6 6"
      stroke="var(--icon-inverse-primary)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9h.01"
      stroke="var(--icon-inverse-primary)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 15h.01"
      stroke="var(--icon-inverse-primary)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BadgePercentIcon;
